import Vue from 'vue';
import { RightSummaryType } from '@/api/rights/types';
import PopStyleB from './popStyleB.vue';

interface PopupResult {
  retainSuccess: boolean;
  submitClick: boolean;
}

export enum ActionTypeEnum {
  CLICK_RREVIEW_CONTRACT = '预览协议',
  CLICK_DETAIL = '查看详情',
  AGREE = '同意协议并提交',
  REJECT = '放弃特权',
}

class PopupBService {
  private instance: Vue | null = null;

  private resolvePromise: ((value: PopupResult) => void) | null = null;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private rejectPromise: ((reason?: any) => void) | null = null;

  /**
   * 显示弹窗
   * @param rightParams 权益参数
   * @returns Promise<PopupResult> 返回用户选择结果
   */
  public show(
    { rightParams, goDetail, contractPreview }:
    { rightParams: RightSummaryType,
      goDetail: () => void,
      contractPreview: () => void
  },
  ): Promise<PopupResult> {
    return new Promise((resolve, reject) => {
      this.resolvePromise = resolve;
      this.rejectPromise = reject;

      // 创建弹窗实例
      if (!this.instance) {
        try {
          this.instance = new Vue({
            render: (h) => h(PopStyleB, {
              props: {
                rightParams,
                modelValue: true,
                goDetail,
                contractPreview,
              },
              on: {
                'update:modelValue': (value: boolean) => {
                  if (!value) {
                    this.hide();
                  }
                },
                choose: (retainSuccess: boolean) => {
                  // this.hide();
                  resolve({ retainSuccess, submitClick: true });
                },
              },
            }),
          });

          // 挂载到DOM
          const mountedDom = document.createElement('div');
          document.body.appendChild(mountedDom);
          this.instance.$mount(mountedDom);
        } catch (error) {
          reject(new Error('弹窗创建失败'));
        }
      } else {
        // 更新参数并显示
        if (this.instance.$children && this.instance.$children.length) {
          this.instance.$children[0].$props.modelValue = true;
          this.instance.$children[0].$props.rightParams = rightParams;
        }
      }
    });
  }

  /**
   * 隐藏弹窗
   */
  public hide(): void {
    if (this.instance) {
      if (this.instance.$children && this.instance.$children.length) {
        this.instance.$children[0].$props.modelValue = false;
      }
    }

    // 如果有未处理的Promise，reject它
    if (this.rejectPromise) {
      this.rejectPromise(new Error('弹窗被关闭'));
      this.rejectPromise = null;
    }
  }

  /**
   * 销毁弹窗实例
   */
  public destroy(): void {
    if (this.instance) {
      this.hide();
      this.instance = null;
    }
  }
}

// 创建单例
const popupBService = new PopupBService();

// 导出服务实例和便捷方法
export default popupBService;

// 便捷的show方法
export const showPopupB = (
  { rightParams, goDetail, contractPreview }:
  { rightParams: RightSummaryType,
    goDetail: () => void,
    contractPreview: () => void
  },
): Promise<PopupResult> => popupBService.show({
  rightParams, goDetail, contractPreview,
});

// 便捷的hide方法
export const hidePopupB = (): void => {
  popupBService.hide();
};

// 便捷的destroy方法
export const destroyPopupB = (): void => {
  popupBService.destroy();
};
